import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalConfirmEmail = ({ confirm, copyButton, iconOff, delegation }) => {
  const [inputEmail, setInputEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const localStorageKey = "emailValidatedData";

  const handleConfirm = () => {
    if (inputEmail.trim() === delegation?.email) {
      setEmailError(false);
      localStorage.setItem(
        localStorageKey,
        JSON.stringify({ validated: true, uid: delegation?.uid }),
      );
      confirm();
    } else {
      setEmailError(true);
      localStorage.setItem(
        localStorageKey,
        JSON.stringify({ validated: false, uid: delegation?.uid }),
      );
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Grid
        container
        item
        xs={11}
        md={7}
        lg={5}
        sx={{
          position: "relative",
          backgroundColor: "#fff",
          maxHeight: "100%",
          width: { xs: "90%", sm: "80%" },
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <Grid
          item
          xs={12}
          style={{
            height: "60px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
          }}
        >
          {iconOff ? (
            <Grid item xs={0} style={{ padding: "10px 0 0 15px" }} />
          ) : null}
          <Grid item xs={10}>
            <Typography
              className="color-blue-dark"
              style={{ fontSize: "18px", fontWeight: 600 }}
            >
              Controllo di validazione
            </Typography>
          </Grid>
        </Grid>

        {/* Testo */}
        <Grid
          item
          xs={12}
          sx={{ padding: "10px 15px 0px 15px", marginTop: "20px" }}
        >
          <Typography className="color-blue-dark">
            Inserisci l'email che hai registrato in precedenza su questo
            processo di delega.
          </Typography>
        </Grid>

        {/* Input email */}
        <Grid
          item
          xs={12}
          sm={8}
          md={9}
          sx={{
            padding: "10px 15px 0px 15px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Typography className="color-blue-dark title-input">Email</Typography>
          <TextField
            sx={{ mt: "5px", position: "relative" }}
            placeholder="Inserisci email"
            fullWidth
            value={inputEmail}
            onChange={(e) => setInputEmail(e.target.value)}
            error={emailError}
            helperText={
              emailError ? "L’email non corrisponde a quella registrata" : ""
            }
            FormHelperTextProps={{ sx: { margin: 0, padding: 0 } }}
            name="email"
            InputProps={{
              sx: {
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C4C4C4 !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C4C4C4 !important",
                  borderWidth: "1px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C4C4C4",
                },
              },
            }}
          />
        </Grid>

        {/* Pulsante conferma */}
        <Grid container item xs={12} style={{ marginTop: "20px" }}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px",
            }}
          >
            <Button
              variant="contained"
              className="button-bg-blue"
              onClick={handleConfirm}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                {copyButton}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ModalConfirmEmail;
